export default "/images/vendor/flag-icon-css/flags/1x1/mq.svg?4caa210d7c5288e95062442967402b43";